import { render, staticRenderFns } from "./invoice-dataview.vue?vue&type=template&id=58ccb960"
import script from "./invoice-dataview.vue?vue&type=script&lang=js"
export * from "./invoice-dataview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports